/**
 * @description Returns the value of a window property if the window object is defined
 * @param property the property of the window you desire to access
 * @returns the value of the property if it exists and if window is defined
 */
const getWindowPropertySafely: <Property extends keyof ExtendedWindow>(
  property: Property,
) => ExtendedWindow[Property] | undefined = (property) => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window[property as keyof ExtendedWindow];
};

export default getWindowPropertySafely;
